import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=74228cce&scoped=true&"
import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=74228cce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74228cce",
  null
  
)

export default component.exports